export const rolePermissionDefaults = {
  Admin: {
    "AHU Machines": { 1: true, 2: true, 3: true, 4: true },
    "AHU Filters": { 1: true, 2: true, 3: true, 4: true },
    "Reports": { 1: true, 2:false, 3: true, 4: false },
    "Activity Log": { 1: true, 2: false, 3: true, 4: false },
    "Users": { 1: true, 2: true, 3: true, 4: true },
    "Permissions": { 1: true, 2: true, 3: true, 4: true },
    "Filter Types": { 1: true, 2: true, 3: true, 4: true },
    "Audit Activities": { 1: true, 2: true, 3: true, 4: true },
    "Filter Activities": { 1: true, 2: true, 3: true, 4: true },
    "Maintenance Stages": { 1: true, 2: true, 3: true, 4: true },
  },
  MaintenanceManager: {
    "AHU Machines": { 1: true, 2: true, 3: true, 4: false },
    "AHU Filters": { 1: true, 2: true, 3: true, 4: false },
    "Reports": { 1: true, 2: false, 3: true, 4: false },
    "Activity Log": { 1: true, 2: false, 3: true, 4: false },
    "Users": { 1: false, 2: false, 3: false, 4: false },
    "Permissions": { 1: false, 2: false, 3: false, 4: false },
    "Filter Types": { 1: false, 2: false, 3: false, 4: false },
    "Audit Activities": { 1: false, 2: false, 3: false, 4: false },
    "Filter Activities": { 1: false, 2: false, 3: false, 4: false },
    "Maintenance Stages": { 1: false, 2: false, 3: false, 4: false },
  },
  MaintenanceUser: {
    "AHU Machines": { 1: true, 2: false, 3: true, 4: false },
    "AHU Filters": { 1: true, 2: false, 3: true, 4: false },
    "Reports": { 1: true, 2: false, 3: true, 4: false },
    "Activity Log": { 1: true, 2: false, 3: false, 4: false },
    "Users": { 1: false, 2: false, 3: false, 4: false },
    "Permissions": { 1: false, 2: false, 3: false, 4: false },
    "Filter Types": { 1: false, 2: false, 3: false, 4: false },
    "Audit Activities": { 1: false, 2: false, 3: false, 4: false },
    "Filter Activities": { 1: false, 2: false, 3: false, 4: false },
    "Maintenance Stages": { 1: false, 2: false, 3: false, 4: false },
  }
};
